import React from 'react'
import { motion } from 'framer-motion'
import { FaBed, FaHome, FaUmbrellaBeach, FaTimesCircle } from 'react-icons/fa'
import './Equipment.css'

const Equipment = () => {
  const equipment = [
    {
      icon: FaBed,
      title: 'První patro',
      items: [
        'Nabízíme vám ubytování v 9-ti pokojích',
        '3× dvojlůžkových',
        '4× čtyřlůžkových',
        '1× pětilůžkový family room (3+2) – společné sociální zařízení',
        '1× sedmilůžkový family room (5+2) – společné sociální zařízení',
        'Celková kapacita 34 osob',
        'Každý pokoj je vybaven vlastním sociálním zařízením',
        'Wi-Fi je k dispozici zdarma v celém objektu',
        'Možnost postýlek pro malé děti',
        "Ložní prádlo"
      ]
    },
    {
      icon: FaHome,
      title: 'Přízemí',
      items: [
        'Veranda s posezením a dětským koutkem',
        'Jídelna s výčepem (chlazení a narážeče na KEG sudy)',
        'Kompletně vybavená prostorná kuchyň',
        'WC – dámské / pánské',
        'Parkování pro hosty na přilehlém parkovišti zdarma'
      ]
    },
    {
      icon: FaUmbrellaBeach,
      title: 'Venkovní terasa',
      items: [
        'Terasa s posezením',
        'Možnost grilování a opékání buřtů'
      ]
    },
    {
      icon: FaTimesCircle,
      title: 'Co na chatě není',
      items: [
        'ručníky',
        'prášek do pračky',
        'tablety do myčky nádobí',
        'utěrky',
        "mýdlo",
        "toaletní papír",
        "jar",
        "odpadkové mytle 60 a 80 litrů"
      ]
    }
  ]

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  }

  return (
    <section className="equipment-section section">
      <div className="container">
        <motion.div
          className="equipment-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h1 className="section-title">Vybavení &amp; dispozice</h1>
          <p className="section-subtitle">Co všechno najdete v naší chatě</p>
        </motion.div>

        <motion.div
          className="equipment-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {equipment.map((category, index) => {
            const Icon = category.icon
            return (
              <motion.div
                key={index}
                className="equipment-card"
                variants={itemVariants}
                whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
              >
                <div className="equipment-icon"><Icon /></div>
                <h3 className="equipment-title">{category.title}</h3>
                <ul className="equipment-list">
                  {category.items.map((item, i) => (
                    <li key={i} className="equipment-item">{item}</li>
                  ))}
                </ul>
              </motion.div>
            )
          })}
        </motion.div>
      </div>
    </section>
  )
}

export default Equipment
